import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42970564"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mission" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "mission__content" }
const _hoisted_4 = { class: "mission__image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "item__content item__title" }
const _hoisted_7 = { class: "item__content item__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.missions, (mission) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "item",
          key: mission
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                class: "icon",
                src: 
                require(`../../assets/static/home/mission-icons/${mission.image}`)
              ,
                alt: "icon"
              }, null, 8, _hoisted_5)
            ]),
            _createElementVNode("h3", _hoisted_6, _toDisplayString(mission.title), 1)
          ]),
          _createElementVNode("p", _hoisted_7, _toDisplayString(mission.description), 1)
        ]))
      }), 128))
    ])
  ]))
}